<script setup lang="ts">
import flower from '../assets/flower/Flower.svg';
import flower1 from '../assets/flower/Flower1.svg';
import flower2 from '../assets/flower/Flower2.svg';
import flower3 from '../assets/flower/Flower3.svg';
import flower4 from '../assets/flower/Flower4.svg';
import flower5 from '../assets/flower/Flower5.svg';
import flower6 from '../assets/flower/Flower6.svg';
import flower7 from '../assets/flower/Flower7.svg';
import flower8 from '../assets/flower/Flower8.svg';
import flower9 from '../assets/flower/Flower9.svg';
import flower10 from '../assets/flower/Flower10.svg';
import useWordOfTheDayStore from '../store/index';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

defineProps<{
  height?: string;
}>();

const store = useWordOfTheDayStore();
const { guesses } = storeToRefs(store);
const currentFlower = computed(() => {
  const flowerIndex = guesses.value;
  switch (flowerIndex) {
    case 1:
      return flower1;
    case 2:
      return flower2;
    case 3:
      return flower3;
    case 4:
      return flower4;
    case 5:
      return flower5;
    case 6:
      return flower6;
    case 7:
      return flower7;
    case 8:
      return flower8;
    case 9:
      return flower9;
    case 10:
      return flower10;
    default:
      return flower; // Default to the first flower if no guesses
  }
});
</script>

<template>
  <img :style="`height: ${height ? height : '40vh'}`" :src="currentFlower" alt="Flower" />
</template>

<style scoped lang="scss">
//
</style>
